import { useContext, useState } from "react";
import { AppContext } from "../Context";

function ParamTuxedo() {
    const { state } = useContext(AppContext);
    const { dispatch } = useContext(AppContext);
    const tuxedos = [{ id: "noTuxedo", caption: "No Tuxedo", img: "noTuxedo.svg", active: true }, { id: "stud", caption: "Studs", img: "stud.svg", active: false }, { id: "studPleat", caption: "Studs With Pleats", img: "studPleat.svg", active: false }];

    function onItemClick(id) {
        dispatch({ type: "SET_TUXEDO", payload: id });
        if (id == "noTuxedo") {
            dispatch({ type: "SET_TUXEDO_PRICE", payload: 0 });
        } else {
            dispatch({ type: "SET_TUXEDO_PRICE", payload: 25 });
        }
        dispatch({ type: "SET_DONE", payload: true });
    }

    return (
        <div className="paramItem">
            <div className="paramHeader">
                <div className="paramTitle">tuxedo</div>
                <div className="paramPrice">+$25</div>
            </div>
            <div className="monoList">
                {tuxedos.map((tuxedo, index) => (
                    <div key={index} className="subMenuType" onClick={() => { onItemClick(tuxedo.id) }}>
                        <img className="fabricImg" src={`${process.env.PUBLIC_URL}/images/${tuxedo.img}`} />
                        <div className="subMenuLabel">{tuxedo.caption}</div>
                        {state.tuxedo === tuxedo.id && (
                            <img
                                className="tick"
                                src={process.env.PUBLIC_URL + "/images/tick.svg"}
                                width={20}
                                alt="selected"
                            />
                        )}
                    </div>
                ))}
            </div>
        </div>
    )
}
export default ParamTuxedo